// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import setShareListDetailModalIsOpen from "@insite/client-framework/Store/Components/ShareListDetailModal/Handlers/SetShareListDetailModalIsOpen";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import FormActions from "@store/Components/Toolkit/FormActions";
/* Starter Custom Code - End */

interface OwnProps {
    extendedStyles?: ShareListDetailModalStyles;
}

export interface ShareListDetailModalStyles {
    modal?: ModalPresentationProps;
    sharedWithAllText?: TypographyPresentationProps;
    buttonsWrapper?: InjectableCss;
    closeButton?: ButtonPresentationProps;
    // Starter Custom Code
    ownerText?: TypographyPresentationProps;
    ownerLabel?: TypographyPresentationProps;
    ownerValue?: TypographyPresentationProps;
}

export const shareListDetailModalStyles: ShareListDetailModalStyles = {
    modal: { sizeVariant: "small" },
    ownerText: { variant: "p" },
    ownerLabel: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    sharedWithAllText: { variant: "p" },
    closeButton: { variant: "secondary" },
};

const ShareListDetailModal = ({ extendedStyles }: OwnProps) => {
    const modalIsOpen = useAppSelector(state => state.components.shareListDetailModal.isOpen);
    const listOwner = useAppSelector(state => state.components.shareListDetailModal.listOwner || "");
    const dispatch = useAppDispatch();

    const [styles] = useState(() => mergeToNew(shareListDetailModalStyles, extendedStyles));

    const modalCloseHandler = () => {
        dispatch(setShareListDetailModalIsOpen({ modalIsOpen: false }));
    };

    return (
        <Modal
            {...styles.modal}
            headline={translate("Share Details")}
            isOpen={modalIsOpen}
            handleClose={modalCloseHandler}
        >
            {/* Starter Custom Code - Start */}
            <Typography {...styles.ownerText}>
                <Typography {...styles.ownerLabel}>{translate("{0}:", translate("List Owner"))}</Typography>
                <Typography {...styles.ownerValue}>{listOwner}</Typography>
            </Typography>
            {/* Starter Custom Code - End */}
            <Typography {...styles.sharedWithAllText}>
                {translate("Shared with all users on billing account.")}
            </Typography>
            <FormActions /* Starter Custom Code */>
                <Button {...styles.closeButton} onClick={() => modalCloseHandler()} data-test-selector="doneButton">
                    {translate("Close")}
                </Button>
            </FormActions>
        </Modal>
    );
};

export default ShareListDetailModal;
